import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private currentLanguageSubject = new BehaviorSubject<string>('es');
  currentLanguage$ = this.currentLanguageSubject.asObservable();

  constructor(private translate: TranslateService, @Inject(DOCUMENT) private document: Document) {
    // Obtén el idioma guardado en localStorage
    const savedLanguage = localStorage.getItem('appLanguage');
    const browserLang = this.translate.getBrowserLang();

    // Determina el idioma inicial
    let initialLang = savedLanguage ||
      (browserLang && ['es', 'en'].includes(browserLang) ? browserLang : 'es');

    // Establece el idioma inicial
    this.setLanguage(initialLang);
  }

  setLanguage(lang: string) {
    this.currentLanguageSubject.next(lang);
    this.translate.use(lang);
    localStorage.setItem('appLanguage', lang);
    moment.locale(lang); // Actualizar el locale de moment

    if (this.document && this.document.documentElement) {
      this.document.documentElement.lang = lang; // Actualizar el atributo lang del documento
    }
  }

  getCurrentLanguage(): string {
    return this.currentLanguageSubject.value;
  }
}
